import { reactive } from 'vue';

const RTLPlugin = {
    install(app) {
        const state = reactive({
            isRTL: false,
        });

        const getDocClasses = () => document.body.classList;

        const enableRTL = () => {
            state.isRTL = true;
            getDocClasses().add('rtl');
            getDocClasses().add('menu-on-right');
            toggleBootstrapRTL(true);
        };

        const disableRTL = () => {
            state.isRTL = false;
            getDocClasses().remove('rtl');
            getDocClasses().remove('menu-on-right');
            toggleBootstrapRTL(false);
        };

        const toggleBootstrapRTL = (value) => {
            for (let i = 0; i < document.styleSheets.length; i++) {
                const styleSheet = document.styleSheets[i];
                const { href } = styleSheet;
                if (href && href.endsWith('bootstrap-rtl.css')) {
                    styleSheet.disabled = !value;
                }
            }
        };
        // Provide the state and methods to the app
        app.provide('rtl', {
            state,
            enableRTL,
            disableRTL,
        });
    },
};

export default RTLPlugin;